<template>
        <card>
           <template slot="header">
              <h3 class="card-title">Responsibility Form</h3>
           </template>   
            <nav class="row">
                 <ol class="breadcrumb arr-right bg-breadcrum">
                    <li class="breadcrumb-item">
                       <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item">
                       <router-link to="responsibilityform">Responsibilities Record</router-link>
                    </li>
                    <li class="breadcrumb-item active">Responsibility Form</li>
                 </ol>
              </nav>
           <hr style="margin-top:-10px"/>
           <br/>
           <form @submit="formSubmit">
              <div class="row">
                 <div class="col-md-4">
                        <div class="form-group"> 
                        <label>Employee Name :</label>
                        <select class="form-control" v-model="emp">
                                <option disabled value="">-- Please select one --</option>
                            <option v-for="emp in items" v-bind:value="emp.id">{{emp.full_name | capitalize}}</option>
                        </select>
                        </div>
                 </div>
                 
              </div>
              <hr style="margin-top:-10px"/>
              <small><i>I hereby acknowledge that I have received the following company property:</i></small><br/><br/>
              <div v-for="(res ,index) in responsibility">
                    <div class="border-box">   
                 <div class="row">
                    <div class="col-md-5">
                       <div class="form-group">  
                          <label>Name Of Item:</label> 
                          <input v-model="res.name" class="form-control">
                       </div>
                    </div>
                    <div class="col-md-4">
                       <div class="form-group">  
                          <label>Description/Serial Number:</label>    
                          <input v-model="res.description" class="form-control">
                       </div>
                    </div>
                    <div class="col-md-1">
                       <div class="form-group">  
                          <label>Quantity:</label>    
                          <integer-plusminus v-model="res.quantity"></integer-plusminus>
                          {{quantity}}
                       </div>
                    </div>
                    <div class="col-md-2">
                       <div class="form-group">  
                          <label>Date Received:</label>    
                          <input type="date" v-model="res.received" class="form-control">
                       </div>
                    </div>
                 </div>
                 </div>
                 <div class="floater-point">
                    <div class="action-item-responsibility">
                       <div class="form-group">
                          <button @click.stop.prevent="add_form" class="btn btn-xs btn-primary"><i class="fa fa-plus"></i></button>
                          <button @click.stop.prevent="delete_form(index)" class="btn btn-xs btn-primary"><i class="fa fa-minus"></i></button>
                       </div>
                    </div>
                 </div>
                 <br/>
              </div>
              <hr style="margin-top:10px"/>
              <small><i>I agree to keep the property in working condition, and to notify management should the property malfunction in any way, or should the property be lost or stolen. <br/> Further, 
                I agree to return this property at the end of my employment. When I no longer need one or more of the items, I will return it/them immediately to my immediate supervisor.</i></small>
              <!-- <pre>{{responsibility}}</pre> -->
              <div class="row">
              <div class="col-md-6"></div>
              <div class="col-md-6">
                    <button class="btn btn-info float-right"><i class="fa fa-save"></i>&nbsp;Submit Responsibility</button> 
                 </div>
                </div>  
               <br/>  
            </form>
        </card>
 </template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
import { IntegerPlusminus } from 'vue-integer-plusminus' 
export default {
   components: {
      Card,
      IntegerPlusminus
   },
   data() {
      return {
         responsibility: [{
            name: '',
            description: '',
            received: '',
         }],
         quantity: '',
         items: [],
         emp: ''
      }
   },
   mounted: function() {
      this.get_employees()
   },
   methods: {
      add_form: function () {
         this.responsibility.push({
            name: '',
            description: '',
            received: '',
         })
      },

      delete_form: function (index) {
         console.log(index);
         console.log(this.finds);
         this.responsibility.splice(index, 1);
         if (index === 0)
            this.add_form()
      },


      formSubmit(e) {
         e.preventDefault();
         this.$swal({
               title: 'Are you sure?',
               text: 'Do you want to save',
               type: 'warning',
               showCancelButton: true,
               showCloseButton: false,
            })
            .then((isConfirm) => {
               if (isConfirm === true) {
                  axios.post('api/manualresponsibility/add', {
                        employee_id: this.emp,
                        responsibility: JSON.stringify(this.responsibility)
                     })
                     .then(resp => {

                        this.$swal('Save', resp.data.success, 'success')
                        this.$router.push({
                           name: 'responsibility-form'
                        })
                        this.clear_data();
                        console.log(resp);

                     })
                     .catch(error => {
                        console.log('response => ', error.response.data);
                     });
               }
            });
      },

      get_employees() {
         axios.get('api/employeenoresponsibility')
            .then(response => {
               this.items = response.data;
            })
            .catch(error => {
               console.log(error.response)
            });
      },

      clear_data() {
         this.responsibility = [{
            name: '',
            description: '',
            received: '',
         }]
      }
   },



}
</script>
<style>
        .bg-breadcrum{
            background:#fff;
         }
         .action-item-responsibility{
             margin-top:-100px;
             position: absolute;
             /* background: yellow; */
             float:right;
         }
         .floater-point{
             float: right;
             width: 100px;
             margin-right: -10px;
             margin-top:-25px;
         }
         .border-box{
             border: 1px solid #ebebee;
             width: 100%;
             padding: 20px;
         }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-responsibility-form/todo-add-responsibility-form.vue